import "./custom.scss";
import ProvideAuth, { PrivateRoute } from "./providers/authprovider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login/Login";
import Main from "./pages/main/Main";
import InstallPrompt from "./components/InstallPrompt";
import OfflineQueueNotifier from "./components/OfflineQueueNotifier";
import { OfflineQueueProvider } from "./providers/offlineQueueProvider";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <ProvideAuth>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="*"
              element={
                <PrivateRoute>
                  <OfflineQueueProvider>
                    <OfflineQueueNotifier />
                    <Main />
                  </OfflineQueueProvider>
                </PrivateRoute>
              }
            />
          </Routes>
        </ProvideAuth>
        <InstallPrompt />
      </BrowserRouter>
    </>
  );
}
